import { connect } from "react-redux";
import { getFlattenedLessonQuestions } from "../../selectors/lessonQuestionSelectors";
import LessonQuestionPagination from "./LessonQuestionPagination";

function mapStateToProps(state) {
  return {
    flattenedLessonQuestions: getFlattenedLessonQuestions(state),
  };
}

export default connect(mapStateToProps)(LessonQuestionPagination);
